export default "__VITE_ASSET__eMCLQOz0__"